import { IVasInfo } from '@r1-frontend/api-domru/api-profile/v1/vas/dto/ResponseDto';
import { TCategory } from '@r1-frontend/api-domru/widgets/v1/vas/dto/RequestDto';
import { TAction } from '@r1-frontend/api-domru/widgets/v1/vas/dto/ResponseDto';

import { ICardActionButton, ICardLinkButton } from '@r1-frontend/ui-react/organisms/Card/CardBricks/CardButtonsWithPrice';
import { TSubscriptionCard } from '@r1-frontend/ui-react/organisms/Card/Subscription';

import { IMultibundleAdditional } from '~/src/store/selectors/vas';

type TSubscriptionActionButton = Omit<ICardActionButton, 'onClick'> & {
    action: Exclude<TAction, 'link'>,
}

export type TSubscriptionLinkButton = ICardLinkButton & {
    action: 'link',
}

export type TSubscriptionButton = TSubscriptionActionButton | TSubscriptionLinkButton;

export type TSubscriptionButtons = [TSubscriptionButton] | [TSubscriptionButton, TSubscriptionButton];

export type TSubscription = Omit<TSubscriptionCard, 'buttons'> & {
    shopItemId: number,
    buttons: TSubscriptionButtons,
};

/**
 * Сервисы, относящиеся к определенной категории {TCategory}
 */
export type TSpecificVas = {
    name: string | null,
    description?: string | null,
    items: TSubscription[],
    showAll?: boolean,
    category?: TCategory,
    multibundle?: IVasInfo<IMultibundleAdditional> | null,
}

export type TVasService = Record<TCategory, TSpecificVas>;

export type TFilterCategory = TCategory;

export type TVasState = {
    loading: boolean,
    loaded: boolean,

    connected: TVasService,
    available: TVasService,

    selectedCategory: TFilterCategory | null,
};

const initialState: TVasState = {
    loading: false,
    loaded: false,

    connected: {
        partnerService: { name: null, items: [] },
        antiviruses: { name: null, items: [] },
        speedBonuses: { name: null, items: [] },
        subscriptions: { name: null, items: [] },
        gameService: { name: null, items: [] },
        tvPackages: { name: null, items: [] },
        additionalTVAndMovixServices: { name: null, items: [] },
    },
    available: {
        partnerService: { name: null, items: [] },
        antiviruses: { name: null, items: [] },
        speedBonuses: { name: null, items: [] },
        subscriptions: { name: null, items: [] },
        gameService: { name: null, items: [] },
        tvPackages: { name: null, items: [] },
        additionalTVAndMovixServices: { name: null, items: [] },
    },

    selectedCategory: null,
};

export default initialState;
